/** @typedef {import('../types.js').MenuStyleProperties} MenuStyleProperties */
/** @typedef {import('../types.js').MegaMenuContainerItemStyleProperties} MegaMenuContainerItemStyleProperties */

const properties = [
    ['dropdown-container-background', 'container-background'],
    ['dropdown-container-border-top', 'container-border-top'],
    ['dropdown-container-border-right', 'container-border-right'],
    ['dropdown-container-border-bottom', 'container-border-bottom'],
    ['dropdown-container-border-left', 'container-border-left'],
    ['dropdown-container-border-radius', 'container-border-radius'],
    ['dropdown-container-box-shadow', 'container-box-shadow']
]

/**
 * @param {MenuStyleProperties} MenuStyleProperties
 * @param {MegaMenuContainerItemStyleProperties} MegaMenuContainerItemStyleProperties
 */
const migrateMegaMenuContainerItemDesign = (MenuStyleProperties, MegaMenuContainerItemStyleProperties) => {
    const migrateRootPropertyToMegaMenuContainerItemProperty = (from, to) => {
        if (!MenuStyleProperties[from]) return

        MegaMenuContainerItemStyleProperties[to] = MenuStyleProperties[from]
    }

    properties.forEach(([from, to]) => migrateRootPropertyToMegaMenuContainerItemProperty(from, to))
}

module.exports = {
    migrateMegaMenuContainerItemDesign
}
